import type { PropsWithChildren } from "react";
import type { GamePageContext } from "../game-types";
import { GameContext } from "./game-context";

export function GameContextProvider({
  game,
  children,
}: PropsWithChildren<{ readonly game: GamePageContext }>) {
  return <GameContext value={game}>{children}</GameContext>;
}
